import React, { useMemo } from 'react';

import WarningIcon from '@material-ui/icons/Warning';
import Tooltip from '@this/src/components/shared/tooltip/tooltip';
import { styled } from '@this/src/components/constants/themes';
import { media } from '@this/src/components/shared/atoms/media';

interface Props {
  restricted?: boolean | null;
  variant?: 'contained' | 'text';
}

const StayPlanWarning: React.FC<Props> = ({ restricted, variant = 'contained' }) => {
  const button = useMemo(() => {
    if (!restricted) return null;

    if (variant === 'text') {
      return (
        <TextTag>
          <WarningIcon />
          制限付きプランの可能性
        </TextTag>
      );
    }

    return (
      <Tag>
        <WarningIcon />
        制限付きプランの可能性
      </Tag>
    );
  }, [restricted, variant]);

  if (!restricted) return null;

  return (
    <Tooltip type={button} place="right" width={400} spWidth={280}>
      <TextContainer>
        <Text>
          このプランは、性別・年齢・居住地などの宿泊者様の属性情報の該当条件、またはアプリダウンロード・アンケート回答などの条件達成が必要となる場合があります。
        </Text>
        <Text>
          お申し込みの際は、「宿泊プラン名」「宿泊プラン詳細」を必ずご確認のうえ、プランをお選びください。
        </Text>
        <Text>
          なお、ご予約後にAI
          Travelのオペレーターからプランの条件を満たすかどうかの確認は行いませんので、あらかじめご了承ください。
        </Text>
      </TextContainer>
    </Tooltip>
  );
};

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  line-height: normal;
`;

const Text = styled.p`
  font-size: 12px;

  ${media.sp`
    font-size: 11px;
  `}
`;

const Tag = styled.span`
  display: flex;
  align-items: center;
  font-size: 10px;
  font-weight: bold;
  color: white;
  background: ${props => props.theme.accentColor};
  gap: 2px;
  padding: 2px 4px;
  border-radius: 4px;
  word-break: keep-all;

  .MuiSvgIcon-root {
    font-size: 14px;
  }
`;

const TextTag = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  color: #959595;
  gap: 2px;
  word-break: keep-all;

  .MuiSvgIcon-root {
    font-size: 16px;
  }
`;

export default StayPlanWarning;
